module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_L3-328fe937a33607607e4f4d070ed1ec28.webp";